'use strict';

(function() {
	angular.module('onboarding.carrier')
		.directive('cobCarrierWelcomeModal', cobCarrierWelcomeModal);

	cobCarrierWelcomeModal.$inject = ['sessionService', '$state', 'subjectObserverMessagesService', 'observerService'];

	var sessionService,
		$state,
		subjectMessages,
		observerMessages,
		subjectObserverMessagesService,
		observerService;

	function cobCarrierWelcomeModal(_sessionService_, _$state_, _subjectObserverMessagesService_, _observerService_) {
		sessionService = _sessionService_;
		$state = _$state_;
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;

		return {
			restrict: 'E',
			scope: {},
			replace: true,
			templateUrl: '/app/carrier/profile/welcomeModal.html',
			link: linkFunction
		};
	}

	function linkFunction(scope) {

		activate();

		function activate() {
			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();
			scope.m = {};
			var broker = sessionService.getBrokerBranding();
			if (broker) {
				scope.m.logoUrl = sessionService.getBrokerLogoURL();
				scope.m.welcomeMessage = broker.welcomeMessage;
				scope.m.brokerName = broker.brokerName;
			}

			scope.hide = hide;
			document.title = 'Profile Steps';
		}

		function hide() {
			document.title = 'Profile-Company';
			$state.go('carrierProfile.company');
		}
	}

})();
